export const environment = {
  production: false,
  apiProjectUrl:
    "https://a314-projects-qa.rockport.avwaveinteractive.com/projects",
  apiUrlAdmin:
    "https://a314-admin-users-qa.rockport.avwaveinteractive.com/admin-users",
  apiGoogleStorage:
    "https://a314-google-storage-qa.rockport.avwaveinteractive.com/storage",
  urlStorage: "https://storage.googleapis.com/rockport-avwave-qa/",
  testUser: {
    // tslint:disable-line
    token: "cualquiercosa",
    email: "user@user.user",
  },
};
